import axios, {
  AxiosInstance,
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';

// import { store } from '@project/store';
declare module 'axios' {
  export interface AxiosInstance {
    request<T = any>(config: AxiosRequestConfig): Promise<T>;
    get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
    delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
    head<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
    post<T = any>(
      url: string,
      data?: any,
      config?: AxiosRequestConfig,
    ): Promise<T>;
    put<T = any>(
      url: string,
      data?: any,
      config?: AxiosRequestConfig,
    ): Promise<T>;
    patch<T = any>(
      url: string,
      data?: any,
      config?: AxiosRequestConfig,
    ): Promise<T>;
  }
}

const TIMEOUT = 2 * 60000;

const DEFAULTCONFIG: AxiosRequestConfig = {
  baseURL: process.env.BACKEND_URL,
  timeout: TIMEOUT,
};

export function getAxiosInstance() {
  const instance: AxiosInstance = axios.create(DEFAULTCONFIG);
  instance.interceptors.request.use((config) => {
    /* ToDo: Пока что непонятно, понадобится токен или нет; */
    // const token = store.userInfo.authToken;
    // if (token !== null) {
    //   config.headers.common['Authorization'] = `Bearer ${token.access}`;
    // }

    return config;
  });
  instance.interceptors.response.use(
    function (response: AxiosResponse) {
      return response.data;
    },
    function (error: AxiosError) {
      // 4xx / 5xx error
      if (error.response) {
        return Promise.reject(error.response.data);
      } else if (error.request) {
        return Promise.reject(error.request);
      } else {
        return Promise.reject(error.message);
      }
    },
  );

  return instance;
}
